/**
 * This component display helps to route the page request to display information on the screen.
 *
 */
import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import Permission from 'spark-util/Permission';
import { paths } from './reportRoutes';

const ReportType = loadableModule(() => import(/* webpackChunkName: "reportType" */ './index'));

const ReportTypeRoute = () => (
    <Permission requires="rm.reportModule">
        <Route path={paths.root} component={ReportType} />
    </Permission>
);

export default ReportTypeRoute;
